import { type FC, useEffect, useMemo } from "react";

import { type Snapshot, useRecoilSnapshot } from "recoil";

const makeRecoilStateMap = (snapshot: Snapshot) => {
    const recoilStateMap = new Map();
    for (const node of snapshot.getNodes_UNSTABLE()) {
        recoilStateMap.set(node.key, snapshot.getLoadable(node));
    }

    return recoilStateMap;
};

export const RecoilDebugObserver: FC = () => {
    const snapshot = useRecoilSnapshot();
    const recoilStateMap = useMemo(() => makeRecoilStateMap(snapshot), [snapshot]);

    useEffect(() => {
        if (window.ENABLE_RECOIL_DEBUG) {
            console.group("Recoil State Debug Observer");
            console.info("%c RECOIL NODES:", "color: #00A881");
            console.info(recoilStateMap);
            console.info();
            console.info("%c RECOIL MODIFIED ATOMS:", "color: #ff8900");
            for (const node of snapshot.getNodes_UNSTABLE({ isModified: true })) {
                console.info(node.key, snapshot.getLoadable(node));
            }
            console.groupEnd();
        }
    }, [snapshot, recoilStateMap]);

    return null;
};
